import { Box, styled, Typography } from '@mui/material';

interface FooterProps {
  uiVersion: string;
  apiVersion?: string;
  apiError?: Error | null;
  legalInformation?: string;
}

const StyledFooter = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  padding: `${theme.hhglobal.spacing.spacing[4].valuePx} 3.2rem`,
  gap: theme.hhglobal.spacing.spacing[1].valuePx,
})) as typeof Box;

const StyledVersionList = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'max-content minmax(0, 1fr)',
  columnGap: theme.hhglobal.spacing.spacing[2].valuePx,
  margin: 0,
})) as typeof Box;

const StyledVersionLabel = styled(Typography)(({ theme }) => ({
  fontSize: theme.hhglobal.typography.body.base.fontSize,
  fontWeight: theme.hhglobal.typography.fontWeights.regular,
  lineHeight: theme.hhglobal.typography.body.base.lineHeight,
  color: theme.hhglobal.purpose.textWeak,
})) as typeof Typography;

const StyledVersionValue = styled(Typography)(({ theme }) => ({
  margin: 0,
  fontSize: theme.hhglobal.typography.body.base.fontSize,
  fontWeight: theme.hhglobal.typography.fontWeights.regular,
  lineHeight: theme.hhglobal.typography.body.base.lineHeight,
  fontVariantNumeric: 'tabular-nums',
  overflowWrap: 'anywhere',
  color: theme.hhglobal.purpose.textWeak,
})) as typeof Typography;

const StyledVersionError = styled(StyledVersionValue)(({ theme }) => ({
  fontWeight: theme.hhglobal.typography.fontWeights.regular,
  color: theme.hhglobal.purpose.error.text,
})) as typeof Typography;

const StyledLegalInformation = styled(Typography)(({ theme }) => ({
  fontSize: theme.hhglobal.typography.body.small.fontSize,
  fontWeight: theme.hhglobal.typography.fontWeights.regular,
  lineHeight: theme.hhglobal.typography.body.small.lineHeight,
  color: theme.hhglobal.purpose.textWeak,
})) as typeof Typography;

function Footer({ uiVersion, apiVersion, apiError, legalInformation }: FooterProps) {
  return (
    <StyledFooter component='footer'>
      <StyledVersionList component='dl'>
        <StyledVersionLabel component='dt'>UI version</StyledVersionLabel>
        <StyledVersionValue component='dd'>{uiVersion}</StyledVersionValue>
        <StyledVersionLabel component='dt'>API version</StyledVersionLabel>
        {apiError ? (
          <StyledVersionError component='dd'>{apiError.message}</StyledVersionError>
        ) : (
          <StyledVersionValue component='dd'>{apiVersion || '-'}</StyledVersionValue>
        )}
      </StyledVersionList>
      {legalInformation && <StyledLegalInformation>{legalInformation}</StyledLegalInformation>}
    </StyledFooter>
  );
}

export default Footer;
